/* RESPONSIBLE TEAM: team-conversations */
import Model, { attr } from '@ember-data/model';

export default class EventActivity extends Model {
  @attr('string') eventName;
  @attr('boolean') usedInLastWeek;
}
